import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=1d135cd2&scoped=true&"
import script from "./resetPassword.vue?vue&type=script&lang=js&"
export * from "./resetPassword.vue?vue&type=script&lang=js&"
import style0 from "./resetPassword.vue?vue&type=style&index=0&id=1d135cd2&lang=scss&scoped=true&"
import style1 from "./resetPassword.vue?vue&type=style&index=1&lang=css&"
import style2 from "./resetPassword.vue?vue&type=style&index=2&id=1d135cd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d135cd2",
  null
  
)

export default component.exports